import * as React from 'react';
import { useDispatch } from 'react-redux';

import { Desktop, NotDesktop } from 'shared/common/packages/Responsive';
import { pushErrorNotification } from 'shared/map-search/actions/notifications';
import { GeoLocation } from 'shared/map-search/components/Icons';
import { GeoLocationNew } from 'shared/map-search/components/Icons/GeoLocationNew';
import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';
import { useMapContext } from 'shared/map-search/containers/Map/context';
import { EErrorNotificationType } from 'shared/map-search/types/notifications';

import { GeoLocationButton } from './GeoLocationButton';

export const GeoLocationButtonContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { map, ymaps } = useMapContext();
  const { logger } = useApplicationContext();

  const handleGeoLocationError = React.useCallback(
    error => {
      logger.error(error, { domain: 'Controls/GeoLocationButton/handleGeoLocationClick()' });

      dispatch(pushErrorNotification(EErrorNotificationType.GeoLocation));
    },
    [logger, dispatch],
  );

  return (
    <>
      <Desktop>
        <GeoLocationButton
          map={map}
          ymaps={ymaps}
          onGeoLocationError={handleGeoLocationError}
          size="M"
          icon={<GeoLocation />}
        />
      </Desktop>
      <NotDesktop>
        <GeoLocationButton
          map={map}
          ymaps={ymaps}
          onGeoLocationError={handleGeoLocationError}
          size="L"
          icon={<GeoLocationNew />}
        />
      </NotDesktop>
    </>
  );
};
